import {entity} from "../../../components/ListComponentEntity";
import {NavLink} from "react-router-dom";
import React from "react";
import {NewList} from "../../../components/NewList/NewList";

export const ListConsumptionNew = (props) => {
    return (
        <NewList
            { ...props } stockNav additionalFieldsExists isFilterExists
            entity={'stock/consumption'}
            entity_type={18}
            requiredFields={'id,name,stock_id,date'}
            requiredExpand={'stock'}
            deleteToShowColumn={'id,name,stock_id,date'}
            filterFields={entity.consumption.fArr}
            singleSearch={entity.consumption.fArr[0]}
            headingColumns={['Номер', 'Статус', 'Дата']}
            RenderColumn={(item) => (
                <>
                    <td>
                        <NavLink to={`/stock/consumption/${item.id}`}  className={'nowrap-list-column'}>{item.name}</NavLink>
                    </td>
                    <td>
                        {item.stock && <span className="label-st" style={{ backgroundColor: 'rgb(255, 193, 100)' }}>{item.stock.name}</span>}
                    </td>
                    <td>
                        <div>{item.date}</div>
                    </td>
                </>
            )}
            createButtonRender={(setModalType) => <button onClick={() => setModalType('consumption')} className="open-modal-button btni">Новое списание</button>}
            rightNavbarConfig={{
                additionalFields: '/fieldsettings/18',
                columns: true
            }}
            massDoConfig={{ deleteAll: `/ajax/stock/consumption/delete-all` }}
            contextNav={{ edit: true, task: true, print: true, delete: true }}
            sort={entity.consumption.fArr.filter(el => el.sort)}
        />
    )
}